//@ts-check
import React from 'react';
import Text from './Text';
import validators from '../../validators';

var NameField = function NameField(props) {
  var other = {
    type: 'text'
  };

  if (props.type === 'fileName') {
    //smart selection
    if (props.selectOnFocus === true) {
      other.selectOnFocus = function (text) {
        return [0, text.indexOf('.')];
      };
    }
  }

  return React.createElement(Text, Object.assign({
    validate: validators.ofType(props.type)
  }, props, other));
};

NameField.defaultProps = {
  type: 'text'
};
export default NameField;